'use client';
import { InstallPwaDialog } from '@/components/InstallPwaDialog';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useManageHubspotMetadata } from '@/hooks/useManageHubspotMetadata';
import '@/locales/i18n';
import { BlurProvider } from '@/providers/BlurProvider';
import { BrowsingHistoryProvider } from '@/providers/BrowsingHistoryProvider';
import { GoogleTagManagerProvider } from '@/providers/GoogleTagManagerProvider';
import { ReactQueryProvider } from '@/providers/ReactQueryProvider';
import { SessionProvider } from '@/providers/SessionProvider';
import { ThemeProvider } from '@/providers/themeProvider';
import '@/strategies';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ToastProvider } from '@treyd-io/treyd-ui/providers/toastProvider';

export const Body = ({ children }: { children: React.ReactNode }) => {
  useManageHubspotMetadata();
  useAnalytics();

  return (
    <AppRouterCacheProvider>
      <BrowsingHistoryProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ReactQueryProvider>
            <ThemeProvider>
              <ToastProvider>
                <SessionProvider>
                  <GoogleTagManagerProvider />
                  <InstallPwaDialog />
                  <BlurProvider>{children}</BlurProvider>
                </SessionProvider>
              </ToastProvider>
            </ThemeProvider>
          </ReactQueryProvider>
        </LocalizationProvider>
      </BrowsingHistoryProvider>
    </AppRouterCacheProvider>
  );
};
